import { GzRemoveFromIsolationTaskWebComponent } from './component/GzRemoveFromIsolationTaskWebComponent';

export { GzRemoveFromIsolationTaskWebComponent };
